import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { alertsQueryOptions, deletePriceAlert } from "../queries/deals";
import { formatPrice } from "../lib/format";

export const Route = createFileRoute("/alerts")({
  beforeLoad: ({ context }) => { if (!context.session) throw redirect({ to: "/login" }); },
  loader: ({ context }) => context.queryClient.ensureQueryData(alertsQueryOptions),
  component: AlertsPage,
});

function AlertsPage() {
  const q = useQuery(alertsQueryOptions);
  const qc = useQueryClient();
  const remove = useMutation({
    mutationFn: deletePriceAlert,
    onSuccess: () => qc.invalidateQueries({ queryKey: alertsQueryOptions.queryKey }),
  });
  return <main className="mx-auto w-full max-w-3xl px-4 sm:px-5 py-8 flex-1">
    <h1 className="text-2xl font-semibold">Price alerts</h1>
    <p className="mt-1 text-sm text-[color:var(--color-fg-muted)]">Triggered when a scraper records your target price or lower.</p>
    <div className="mt-6 space-y-3">
      {q.data?.length === 0 && <p className="text-[color:var(--color-fg-muted)]">No alerts yet. Set one from a deal page.</p>}
      {q.data?.map((alert) => <article key={alert.id} className="rounded-lg border border-[color:var(--color-line)] bg-[color:var(--color-panel)] p-4">
        <div className="flex justify-between gap-4">
          <div>
            <p className="text-xs font-medium text-[color:var(--color-fg-muted)]">{alert.triggeredAt ? "🔔 Target reached" : "Watching"}</p>
            <Link to="/deal/$id/$slug" params={{ id: alert.dealId, slug: alert.deal.slug }} className="mt-1 block font-semibold hover:underline">{alert.deal.title}</Link>
            <p className="mt-1 text-sm">Now {formatPrice(alert.deal.priceCents, alert.deal.currency)} · target {formatPrice(alert.targetPriceCents, alert.deal.currency)}</p>
          </div>
          <button type="button" onClick={() => remove.mutate(alert.dealId)} className="text-sm text-[color:var(--color-fg-muted)] hover:text-[color:var(--color-red)]">Remove</button>
        </div>
      </article>)}
    </div>
  </main>;
}
